import styled from 'styled-components';

export const LeftSelf = styled.div`
  justify-self: left;
`;

export const RightSelf = styled.div`
  justify-self: right;
`;
